import React from "react";

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console
    console.error("Caught error:", error, errorInfo);

    // Optionally send error to monitoring service
    // logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ color: "red", padding: "1rem" }}>
          <h1>Something went wrong.</h1>
          <p>Error: {this.state.error}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
